import { parseListingDate } from 'components/propertyCard/listingCardAvailability'

export const LISTING_SORT_OPTIONS = [
  'newest',
  'priceAsc',
  'priceDesc',
  'availabilitySoonest',
] as const

export type ListingSortOption = (typeof LISTING_SORT_OPTIONS)[number]

export const DEFAULT_LISTING_SORT: ListingSortOption = 'newest'

type SortableListing = {
  id?: string | number
  price?: string | number | null
  availability?: string | null
  createdAt?: string | null
  created_at?: string | null
}

function parsePrice(price: string | number | null | undefined): number {
  if (typeof price === 'number') return Number.isFinite(price) ? price : Number.POSITIVE_INFINITY
  if (price == null) return Number.POSITIVE_INFINITY
  const parsed = Number(String(price).replace(',', '.').replace(/[^\d.-]/g, ''))
  return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY
}

function parseCreatedAt(item: SortableListing): number {
  const raw = item.createdAt ?? item.created_at
  if (!raw) return 0
  const time = new Date(raw).getTime()
  return Number.isNaN(time) ? 0 : time
}

function parseAvailabilityTime(raw: string | null | undefined): number {
  const date = parseListingDate(raw)
  return date ? date.getTime() : Number.POSITIVE_INFINITY
}

export function sortListings<T extends SortableListing>(
  listings: T[],
  sortBy: ListingSortOption
): T[] {
  const sorted = [...listings]

  switch (sortBy) {
    case 'priceAsc':
      sorted.sort((a, b) => parsePrice(a.price) - parsePrice(b.price))
      break
    case 'priceDesc':
      sorted.sort((a, b) => parsePrice(b.price) - parsePrice(a.price))
      break
    case 'availabilitySoonest':
      sorted.sort(
        (a, b) => parseAvailabilityTime(a.availability) - parseAvailabilityTime(b.availability)
      )
      break
    case 'newest':
    default:
      sorted.sort((a, b) => parseCreatedAt(b) - parseCreatedAt(a))
      break
  }

  return sorted
}
